import React from 'react';

export default function ToggleBtn({ toggleQuizFocus, setToggleQuizFocus }) {
  return (
    <button
      className="  bg-[#6369FF] text-white py-1 md:py-2 px-3 rounded my-3 hover:bg-[#5559e1] font-semibold disabled:bg-zinc-400  md:text-base text-xs"
      onClick={() => {
        setToggleQuizFocus(!toggleQuizFocus);
      }}
    >
      {toggleQuizFocus ? (
        <span className="cursor-pointer pointer-events-auto">
          <object
            type="image/svg+xml"
            data="/stocksvgs/back.svg"
            className="inline-block pr-2 pointer-events-none w-5 h-5 md:w-8 md:h-8"
            aria-label="Back"
          ></object>
          Player
          <object
            type="image/svg+xml"
            data="/stocksvgs/player.svg"
            className="inline-block pl-2 pointer-events-none w-5 h-5	md:w-8 md:h-8"
            aria-label="Player"
          ></object>
        </span>
      ) : (
        <div className="cursor-pointer">
          Focus
          <object
            type="image/svg+xml"
            data="/stocksvgs/focus.svg"
            className="inline-block pl-2 pointer-events-none w-8 h-8	"
            aria-label="Focus"
          ></object>
        </div>
      )}
    </button>
  );
}
